import React, { useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ajouterMarque } from "../../../Services/Facturation/FacturationMarqueApi";
import { t } from "i18next";

function AddMarque({ getData }) {
  const refHideModal = useRef();
  const [plafond, setPlafond] = useState("");
  const [libelle, setlibelle] = useState("");

  /**
   * It adds a new marque to the database.
   */
  const handleSubmit = () => {
    if (libelle == "") {
      toast.error("nom vide");
    } else if (plafond == "") {
      toast.error("plafond vide");
    } else if (plafond !== "" && isNaN(plafond)) {
      toast.error("plafond doit etre un nombre");
    } else {
      ajouterMarque(libelle, plafond).then((res) => {
        getData();
        refHideModal.current.click();
        // history.push("/facturation/marque")
      });
    }
  };

  return (
    <div
      className="modal fade"
      id="marqueModal"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="marqueModalTitle"
      aria-hidden="true"
    >
      <ToastContainer></ToastContainer>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              {t("Ajouter marque")}
            </h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">{t("Nom")} </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="..."
                  onChange={(e) => setlibelle(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputPassword1">{t("Plafond crédit")}</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="..."
                  onChange={(e) => setPlafond(e.target.value)}
                />
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-dismiss="modal" ref={refHideModal}>
              {t("Annuler")}
            </button>
            <button onClick={handleSubmit} className="btn btn-primary">
              {t("Enregistrer")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddMarque;
